import React from 'react';
import Section from './Section';
import Header from './Header';
import Sections from './Sections';
import EquipmentList from './EquipmentList';
import CallToAction from './CallToAction';
import CheckList from './CheckList';
import { BgImage, RequestBgImage, Wrapper } from './styled';
import FixedWidthHeader from '~/src/components/Presentation/Header/fixedWidthHeader';
import { getBundleChannelsCount, getTariffId, getTariffPrice, getTariffSpeed } from '~/src/helpers/formatter';
import { PRODUCTS } from '~/src/constants';

const Presentation = ({
    bgColor,
    productPage,
    textColor,
    fixedWidth,
    gift,
    buffer,
    hidePriceLabel,
    revertDescBlocks,
    typeImage,
    isEquipments = false,
    isCheckList,
    headerBgColor = null,
    headerTextColor = null,
    textBottomForm = null,
    formEmail,
    isAuth,
    sizeMedium,
    newSubtitle,
    productMeta,
    hostname,
    hasButtonForm,
    potentialHeader,
    isRKTariff,
    ...props
}) => {

    const properties = {
        price: 0,
        speed: 0
    };

    const productRequestFormProps = {};
    if (productPage.product_type === 'internet' || productPage.product_type === 'bundles') {
        properties.price = getTariffPrice(productPage.product, productPage.product_type, isAuth);
        properties.speed = getTariffSpeed(productPage.product, productPage.product_type);
        if (productPage.product_type === 'bundles') {
            properties.channels = getBundleChannelsCount(productPage.product);
        }

        productRequestFormProps.product_id = PRODUCTS.internet;
        productRequestFormProps.plan = getTariffId(productPage.product, productPage.product_type);
    }

    const headerData = productPage.contentBlocks.main;
    const headerBackgroundColor = headerBgColor || headerData.bg_color;
    const requestData = productPage.contentBlocks.request;
    const requestFeatures = productPage.product.features;

    let subtitle = headerData.subtitle;
    if (newSubtitle && newSubtitle !== '') {
        subtitle = newSubtitle;
    }

    const _bgColor = bgColor || productPage.bg_color;
    const _textColor = textColor || productPage.text_color;
    const _formEmail = formEmail || productPage.formEmail;
    const _sizeMedium = sizeMedium || productPage.sizeMedium;

    const buttonText = isRKTariff ? headerData.button_text + ' за ' + properties.price + ' ₽' : headerData.button_text;

    const header = fixedWidth
        ?   <FixedWidthHeader
                subtitle={subtitle}
                title={headerData.title}
                buttonText={buttonText}
                link={headerData.link}
                image={headerData.image}
                imageWebp={headerData.imageWebp}
                bgColor={_bgColor}
                properties={properties}
                textColor={_textColor}
                hasButtonForm={hasButtonForm}
                potentialHeader={potentialHeader}
                isRKTariff={isRKTariff}
            />
        : <Section
                bgImage={headerData.image && <BgImage image={headerData.image} />}
                header
                typeImage={typeImage}
                image={headerData.image}
                bgColor={headerBackgroundColor}
            >
                <Header
                    subtitle={subtitle}
                    title={headerData.title}
                    buttonText={buttonText}
                    link={headerData.link}
                    properties={properties}
                    textColor={headerData.text_color || headerTextColor}
                    productProperties={productPage.productProperties || []}
                    productMeta={productMeta}
                    isRKTariff={isRKTariff}
                />
            </Section>;

    const requestSection = !isCheckList && requestData
        ? <Section bgImage={<RequestBgImage image={requestData.image} hiddenImageForMobile customStyle={productPage.requestBgImageStyle}/>} bgColor={requestData.bg_color} id='request'>
            <CallToAction
                title={requestData.title}
                buttonText={requestData.button_text}
                properties={properties}
                textColor={requestData.text_color || _textColor}
                formEmail={_formEmail}
                productProperties={productPage.productProperties || []}
                productRequestFormProps={productRequestFormProps}
                hostname={hostname}
            />
        </Section> : '';

    return (
        <Wrapper textColor={_textColor} itemScope itemType='http://schema.org/Product'>
            { headerData && header }
            <Sections
                bgColor={_bgColor}
                sectionsData={requestFeatures}
                gift={gift}
                buffer={buffer}
                hidePriceLabel={hidePriceLabel}
                revertDescBlocks={revertDescBlocks}
                sizeMedium={_sizeMedium}
            />
            {isEquipments && <EquipmentList/>}
            {isCheckList && <CheckList textBottomForm={textBottomForm}/>}

            {requestSection}

            { props.children }
        </Wrapper>
    );
};

export default Presentation;
